<div class="breadcrumbs">
    <ul class="flex">
        <li *ngFor="let page of pageInfo;let i = index; let last = last"><span *ngIf="i>0"> <img src="assets/imgs/breadcrumbs-arrow.png" alt=""> </span><a [ngClass]="{'no-cursor': last}" href="javascript:void(0)" [routerLink]="page.url">{{page.title}}</a></li>
    </ul>
</div>


